import '../static/FieldFooter.css';
import * as React from "react";
import React__default, { memo } from "react";
import clsx from "clsx";
import { b as Paragraph } from "./Paragraph.DAcb0zW2.mjs";
const SvgCircleCheck1Px = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16m3.354 6.354a.5.5 0 0 0-.708-.708L9 11.293 7.354 9.646a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0z", clipRule: "evenodd" }));
const SvgCircleAlert1Px = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-3.833a.5.5 0 0 1 .5.5V10a.5.5 0 1 1-1 0V6.667a.5.5 0 0 1 .5-.5m0 6.666a.5.5 0 1 0 0 1h.009a.5.5 0 1 0 0-1z", clipRule: "evenodd" }));
const fieldfooter = `_fieldfooter_770a0b8`;
const success = `_success_0156a27`;
const error = `_error_c896589`;
const neutral = `_neutral_ddf3499`;
const styles = { fieldfooter, success, error, neutral };
const FOOTER_TYPE = ["success", "error", "neutral"];
const IconSuccess = () => /* @__PURE__ */ React__default.createElement(SvgCircleCheck1Px, null);
const IconError = () => /* @__PURE__ */ React__default.createElement(SvgCircleAlert1Px, null);
const getStatus = ({
  errorMessage,
  helperMessage,
  successMessage
}) => {
  if (errorMessage) {
    return {
      icon: IconError,
      type: FOOTER_TYPE[1],
      message: errorMessage
    };
  }
  if (successMessage) {
    return {
      icon: IconSuccess,
      type: FOOTER_TYPE[0],
      message: successMessage
    };
  }
  return {
    type: FOOTER_TYPE[2],
    message: helperMessage
  };
};
const FieldFooter = memo(
  ({ className, successMessage, errorMessage, helperMessage, ...props }) => {
    const status = getStatus({ successMessage, errorMessage, helperMessage });
    if (!status.message)
      return null;
    return /* @__PURE__ */ React__default.createElement(
      Paragraph,
      {
        size: "xs",
        "data-testid": `ui-field-footer-${status.type}`,
        className: clsx(styles.fieldfooter, styles[status.type], className),
        ...props
      },
      status.icon && /* @__PURE__ */ React__default.createElement(status.icon, null),
      status.message
    );
  }
);
export {
  FOOTER_TYPE as F,
  FieldFooter as a
};
//# sourceMappingURL=FieldFooter.C6wlZlKr.mjs.map
